//中国大陆手机号
const mobileReg = /^((\+?00[- ]?86[- ]?)|(\+?86[- ]?))?1[3|4|5|6|7|8|9]\d{9}$/

const containMobileReg = /((\+?00[- ]?86[- ]?)|(\+?86[- ]?))?1[3|4|5|6|7|8|9]\d{9}/

export {
	mobileReg,
	containMobileReg
}



// WEBPACK FOOTER //
// ./src/util/regs.js